import * as React from 'react';

import {FORM_ADD_ON_ID} from './consts';
import type {CustomAddOn} from './custom-add-on-select-modal';

type Props = {
    addOnType: CustomAddOn;
};

/**
 * This is used to render a custom add-on block empty state in the Bee editor. We render it as a string
 * using ReactDOMServer, and styles must be applied in-line to work!
 */
export function CustomAddOnEmptyState(props: Props) {
    let titleNoun, subtitleNoun;
    if (props.addOnType === FORM_ADD_ON_ID) {
        titleNoun = 'Nutshell Form';
        subtitleNoun = 'Forms';
    } else {
        titleNoun = 'Nutshell Scheduler';
        subtitleNoun = 'Scheduler meetings';
    }

    return (
        <div style={{maxWidth: 300, marginBottom: 16, marginTop: 8}}>
            <div style={{fontSize: 16, fontWeight: 600, marginBottom: 16}}>
                Add a {titleNoun} to this page
            </div>
            <div>
                {subtitleNoun} you’ve built in Nutshell can be embedded right inside of any landing
                page.
            </div>
        </div>
    );
}
